/** How often the module ticks a room (`fk_wild::TICK_MS`). */
export const TICK_MS = 2000;
